var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"LKAsideMenuItem",attrs:{"to":_vm.to,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var isActive = ref.isActive;
var navigate = ref.navigate;
var isExactActive = ref.isExactActive;
return [_c('a',{staticClass:"aside__link w-inline-block",class:{
      'w--current': isActive || isExactActive,
      'is-active': isActive || isExactActive,
      'is-disabled': _vm.disabled,
    },attrs:{"href":href},on:{"click":navigate}},[_c('v-badge',{attrs:{"value":_vm.newCount > 0,"content":_vm.newCount,"color":_vm.color,"inline":"","overlap":""}},[_c('div',{staticClass:"text-lg-bold mod--aside",domProps:{"textContent":_vm._s(_vm.label)}})]),_c('div',{staticClass:"aside__link-number"},[(!_vm.loading)?_c('div',{staticClass:"text-sm",domProps:{"textContent":_vm._s(_vm.countNumber)}}):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#4a759d","size":"24","width":"2"}})],1)],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }